// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"RSbJdVAPJCYEBqzDjiIg","tooltipText":"mcPZn8lyCCh3Jquaorij","below":"Kg6gtjDkut8us4h66H6y","left":"yFxLOzWPe7fdk3bhBsaW"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"tooltipContainer\":\"RSbJdVAPJCYEBqzDjiIg\",\"tooltipText\":\"mcPZn8lyCCh3Jquaorij\",\"below\":\"Kg6gtjDkut8us4h66H6y\",\"left\":\"yFxLOzWPe7fdk3bhBsaW\"}";
        // 1791380110670
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  